/* eslint-disable @typescript-eslint/no-empty-function */
/* eslint-disable max-classes-per-file */
/**
 * Load all process definition
 */
export class AddAttachmentFileType {
  static readonly type = '[BaseShared] Attachments';

  constructor(public key: string,public data: any) { }
}

/**
 * Moved local storage data to store
 */
export class UserInfo {
  static readonly type = '[BaseShared] UserInfo';

  constructor(public key: string,public data: any) { }
}


export class DashboardToken {
  static readonly type = '[BaseShared] DashboardToken';

  constructor() { }
}
export class StandardReportToken {
  static readonly type = '[BaseShared] StandardReportToken';

  constructor() { }
}

/**
 * All BPS related data to use on landing page
 */
// export class UserBpsTaskInfo {
//   static readonly type = '[BaseShared] UserBpsTaskInfo';

//   constructor(public key: string,public data: any) { }
// }

/**
 * All SEZ related data to use on landing page
 */
export class UserSezInfo{
  static readonly type = '[BaseShared] UserSezInfo';

  constructor(public key: string,public data: any) { }
}

/**
 * rdm: string[] : array of reftype
 * module: string : main route value of module from business.route.ts like -> 'ics-declaration'
 */
export class LoadBaseRdm{
  static readonly type = '[BaseShared] LoadBaseRdm';
  constructor(public rdm: string[], public module: string, public status?: string) { }
}

/**
 *Add all business route path
 */
export class AddModulesPath{
  static readonly type = '[BaseShared] AddModulesPath';
  constructor(public modules: string[]) { }
}

export class LazyLoadModuleStatusLoad{
  static readonly type = '[BaseShared] LazyLoadModuleStatusLoad';
  constructor(public moduleStatus: any) { }
}

export class LoadDeclSchema {
  static readonly type = "[LoadDeclSchema] Schema";
}

export class LoadIntelligenceSchema {
  static readonly type = "[LoadIntelligenceSchema] Schema";
}


export class LoadRdmRefValue {
  static readonly type = "[RefType] LoadRdmRefValue";
}

